var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("AttributeEditorDialog", {
        attrs: { viewModel: _vm.attributeEditorDialog },
        on: { "attribute-created": _vm.loadAttribute },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right" }, [
              !_vm.Processing
                ? _c("div", [
                    _vm.ImportStep === "mappings"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: { padding: "0.7em 2em" },
                            attrs: { type: "button" },
                            on: { click: _vm.cancelImport },
                          },
                          [_vm._v("Back")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.NextToAlternativesAttributesMappingsButtonVisible
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: { padding: "0.7em 2em" },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.ImportStep = "mappings"
                              },
                            },
                          },
                          [_vm._v("Next")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ImportStep === "mappings"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            staticStyle: { padding: "0.7em 2em" },
                            attrs: { type: "button" },
                            on: {
                              click:
                                _vm.handleImportAlternativesFromSpreadsheetCommand,
                            },
                          },
                          [_vm._v("Import")]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _vm.ImportStep === "source"
          ? _c(
              "div",
              [
                _c("div", { staticClass: "card-deck" }, [
                  _c("div", { staticClass: "card bg-light mb-3" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("h5", { staticClass: "card-title" }, [
                        _vm._v("Import tips"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          "\n                            The best way to import your data is to use our\n                            "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "text-primary",
                            on: {
                              click:
                                _vm.handleDownloadEmptyAlternativesSpreadsheetCommand,
                            },
                          },
                          [_vm._v("sample import file")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          "\n                            If you want to use your custom file, here are our recommendations about its structure:\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._m(1),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card text-dark bg-light mb-3" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-footer" }, [
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.UpdateExisting,
                              expression: "UpdateExisting",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.UpdateExisting)
                              ? _vm._i(_vm.UpdateExisting, null) > -1
                              : _vm.UpdateExisting,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.UpdateExisting,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.UpdateExisting = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.UpdateExisting = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.UpdateExisting = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { staticClass: "form-check-label" }, [
                          _vm._v(
                            "\n                                Check this box to update data for existing alternatives. Leave it unchecked if you only want to add new alternatives from your spreadsheet.\n                            "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("Choose file to import (.xls or .xlsx)")]),
                _vm._v(" "),
                _c("FileUploader", {
                  on: {
                    selected: function ($event) {
                      _vm.file = $event
                    },
                    unselected: function ($event) {
                      _vm.file = null
                    },
                    uploaded: _vm.loadMappings,
                  },
                }),
                _vm._v(" "),
                _vm.rm && _vm.rm.HasErrors
                  ? _c(
                      "div",
                      [
                        _vm._l(_vm.SpreadsheetErrors, function (err) {
                          return _c("strong", { staticClass: "fg-color-red" }, [
                            _vm._v(_vm._s(err)),
                          ])
                        }),
                        _c("br"),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.ImportStep === "mappings"
          ? _c("div", [
              _c("h4", [_vm._v("Map columns to attributes")]),
              _vm._v(" "),
              _c("table", { staticClass: "table table-bordered" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.rm.Mappings, function (m) {
                    return _c(
                      "tr",
                      {
                        key: m.ColumnName,
                        class: { "table-warning": m.PropertyName === "None" },
                      },
                      [
                        _c("td", [_vm._v(_vm._s(m.ColumnName))]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: m.PropertyName,
                                  expression: "m.PropertyName",
                                },
                              ],
                              staticClass: "Value form-control",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    m,
                                    "PropertyName",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "None" } }, [
                                _vm._v("[Do not import]"),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "Name" } }, [
                                _vm._v("Name"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "Description" } },
                                [_vm._v("Description")]
                              ),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "Status" } }, [
                                _vm._v("Status"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.AttributesOrdered, function (attr) {
                                return _c(
                                  "option",
                                  {
                                    key: attr.Id,
                                    domProps: { value: attr.Name },
                                  },
                                  [_vm._v(_vm._s(attr.Name))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "error SpreadsheetError" }, [
                            _vm._v(_vm._s(m.Error)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.showAttributeCreator(m)
                                },
                              },
                            },
                            [_vm._v("Create attribute")]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("br"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.ImportStep === "summary"
          ? _c("div", { staticStyle: { height: "100%" } }, [
              _c("h4", [
                _vm._v(
                  _vm._s(
                    _vm.ImportCompleted
                      ? "Import completed"
                      : "Import in progress..."
                  ) + "  "
                ),
              ]),
              _vm._v(" "),
              _vm.importResult
                ? _c("div", [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-3" }, [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("h4", [
                          _vm._v(_vm._s(_vm.importResult.Created.length)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("h4", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.importResult.Updated.length +
                                  _vm.importResult.NotChanged.length
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.importResult.Created.length +
                                _vm.importResult.Updated.length +
                                _vm.importResult.NotChanged.length
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _vm._m(7),
                        _vm._v(" "),
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.importResult.FailedToCreate.length +
                                _vm.importResult.FailedToUpdate.length
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "overflow-x": "hidden",
                          "font-family": "'Consolas', 'Courier New', monospace",
                          "line-height": "1.5",
                          "font-size": "16px",
                        },
                      },
                      [
                        _vm.importResult.FailedToCreate.length
                          ? _c(
                              "div",
                              [
                                _c("strong", { staticClass: "fg-color-red" }, [
                                  _vm._v(
                                    "Failed to create (" +
                                      _vm._s(
                                        _vm.importResult.FailedToCreate.length
                                      ) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.importResult.FailedToCreate,
                                  function (a) {
                                    return _c(
                                      "div",
                                      {
                                        key: `create-${a}`,
                                        staticStyle: { "margin-left": "20px" },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "fg-color-red" },
                                          [_vm._v(_vm._s(a))]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.getError(a))),
                                        ]),
                                        _c("br"),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.importResult.FailedToUpdate.length
                          ? _c(
                              "div",
                              [
                                _c("strong", { staticClass: "fg-color-red" }, [
                                  _vm._v(
                                    "Failed to update (" +
                                      _vm._s(
                                        _vm.importResult.FailedToUpdate.length
                                      ) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.importResult.FailedToUpdate,
                                  function (a) {
                                    return _c(
                                      "div",
                                      {
                                        key: `update-${a}`,
                                        staticStyle: { "margin-left": "20px" },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "fg-color-red" },
                                          [_vm._v(_vm._s(a))]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.getError(a))),
                                        ]),
                                        _c("br"),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.importResult.Created.length
                          ? _c(
                              "div",
                              [
                                _c(
                                  "strong",
                                  { staticClass: "fg-color-green" },
                                  [
                                    _vm._v(
                                      "Created (" +
                                        _vm._s(
                                          _vm.importResult.Created.length
                                        ) +
                                        ")"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.importResult.Created, function (a) {
                                  return _c(
                                    "div",
                                    {
                                      key: `created-${a}`,
                                      staticStyle: { "margin-left": "20px" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fg-color-green" },
                                        [_vm._v(_vm._s(a))]
                                      ),
                                      _c("br"),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.importResult.Updated.length
                          ? _c(
                              "div",
                              [
                                _c(
                                  "strong",
                                  { staticClass: "fg-color-green" },
                                  [
                                    _vm._v(
                                      "Updated (" +
                                        _vm._s(
                                          _vm.importResult.Updated.length
                                        ) +
                                        ")"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.importResult.Updated, function (a) {
                                  return _c(
                                    "div",
                                    {
                                      key: `updated-${a}`,
                                      staticStyle: { "margin-left": "20px" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fg-color-green" },
                                        [_vm._v(_vm._s(a))]
                                      ),
                                      _c("br"),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.importResult.NotChanged.length
                          ? _c(
                              "div",
                              [
                                _c("strong", [
                                  _vm._v(
                                    "No changes detected (" +
                                      _vm._s(
                                        _vm.importResult.NotChanged.length
                                      ) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.importResult.NotChanged,
                                  function (a) {
                                    return _c(
                                      "div",
                                      {
                                        key: `notchanged-${a}`,
                                        staticStyle: { "margin-left": "20px" },
                                      },
                                      [
                                        _c("span", [_vm._v(_vm._s(a))]),
                                        _c("br"),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Import")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", [
      _c("li", [_vm._v("Use columns as attributes and rows as data")]),
      _vm._v(" "),
      _c("li", [_vm._v('Include "Name" column to indicate unique name')]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          'Optionally include "Description" column to indicate description to be used'
        ),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("Avoid merged cells, images, charts")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card-body" }, [
      _c("h5", { staticClass: "card-title text-danger" }, [
        _vm._v("DANGER: YOUR DATA MAY BE DELETED"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "card-text" }, [
        _vm._v(
          '\n                            When importing data from a spreadsheet, you can choose whether or not to import data for existing projects/alternatives.\n                            When you do import these data, any blanks in your spreadsheet will effectively "delete" any data already in TransparentChoice.\n                        '
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Column name")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Attribute name")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("New:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Existing:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Processed:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("strong", [_vm._v("Failed:")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }